export default __webpack_public_path__ + "static/media/logo.0c1d283f.png";